<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-on:click.stop="emitClick"
        v-bind="attrs"
        v-on="on"
        :disabled="disableIcon"
      >
        {{icon}}
      </v-icon>
    </template>
    <span>{{name}}</span>
  </v-tooltip>
</template>

<script>
export default {
  props:{
    icon:{
      type:String,
      default:""
    },
    name:{
      type:String,
      default:""
    },
    disableIcon: {
      type: Boolean,
      default:false
    }
  },
  methods:{
    emitClick(){
      this.$emit('clicked')
    }
  }
}
</script>
<style>
  .mdi-check-circle-outline{
    color: #03a691!important;
  }
  .mdi-close-circle-outline{
    color: #fa503f!important;
  }
  .mdi-delete{
    color: #689ded!important;
    min-width: 31px;
    max-width: 31px;
  }
  .mdi-pencil{
    color: #689ded!important;
    min-width: 31px;
    max-width: 31px;
  }
  .mdi-lock{
    color: #689ded!important;
    min-width: 35px;
    max-width: 35px;
  }
  .mdi-check{
    color: #03a691!important;
    min-width: 31px;
    max-width: 31px;
  }
  .mdi-close-circle-outline{
    color: #fa503f!important;
  }
  .mdi-check-circle-outline{
    color: #03a691!important;
  }
  .v-icon.mdi-check{
    min-width: 35px;
   max-width: 35px;
  }
  .mdi-email-check-outline{
    color: #03a691!important;
  }
  .v-icon.mdi-reload{
    min-width: 35px;
    max-width: 35px;
  }
  .mdi-reload{
    color: #fa503f!important;
    min-width: 31px;
    max-width: 31px;
  }
  .mdi-qrcode-edit{
    color: #689ded!important;
    min-width: 31px;
    max-width: 31px;
  }
   @media (max-width: 1460px) {
    .mdi-delete{
      color: #689ded!important;
      min-width: 25px;
      max-width: 25px;
    }
    .mdi-pencil{
      color: #689ded!important;
      min-width: 25px;
      max-width: 25px;
    }
    .mdi-lock{
      color: #689ded!important;
      min-width: 25px;
      max-width: 25px;
    }
    .mdi-check{
      color: #03a691!important;
      min-width: 25px;
      max-width: 25px;
    }
    .mdi-reload{
      color: #fa503f!important;
      min-width: 25px;
      max-width: 25px;
    }
    .mdi-qrcode-edit{
      color: #689ded!important;
      min-width: 25px;
      max-width: 25px;
    }
  }
  @media (max-width: 1460px) {
    .mdi-delete{
      font-size: 20px!important;
    }
    .mdi-pencil{
      font-size: 20px!important;
    }
    .mdi-lock{
      font-size: 20px!important;
    }
    .mdi-check{
      font-size: 20px!important;
    }
    .mdi-reload{
      font-size: 20px!important;
    }
    .mdi-qrcode-edit{
      font-size: 20px!important;
    }
  }
</style>